import React, { Component } from 'react';
import Tooltip from '../tooltip';
import warning from '../_util/warning';
import ConfigContext from '../config-provider/ConfigContext';
export default class Popover extends Component {
    constructor() {
        super(...arguments);
        this.getOverlay = () => {
            const { title, content } = this.props;
            const prefixCls = this.getPrefixCls();
            warning(!('overlay' in this.props), 'Popover[overlay] is removed, please use Popover[content] instead');
            const header = typeof title === 'function' ? title() : title;
            return (React.createElement("div", null,
                header && React.createElement("div", { className: `${prefixCls}-title` }, header),
                React.createElement("div", { className: `${prefixCls}-inner-content` }, typeof content === 'function' ? content() : content)));
        };
        this.saveTooltip = (node) => {
            this.tooltip = node;
        };
    }
    static get contextType() {
        return ConfigContext;
    }
    getPopupDomNode() {
        return this.tooltip.getPopupDomNode();
    }
    getPrefixCls() {
        const { prefixCls } = this.props;
        const { getPrefixCls } = this.context;
        return getPrefixCls('popover', prefixCls);
    }
    render() {
        const props = { ...this.props };
        delete props.title;
        return (React.createElement(Tooltip, Object.assign({}, props, { prefixCls: this.getPrefixCls(), ref: this.saveTooltip, overlay: this.getOverlay })));
    }
}
Popover.displayName = 'Popover';
Popover.defaultProps = {
    placement: 'top',
    transitionName: 'zoom-big',
    trigger: 'hover',
    mouseEnterDelay: 0.1,
    mouseLeaveDelay: 0.1,
    overlayStyle: {},
};
